// Phase 1A Phase 9C.2 — Intelligence mode + spatial Exchange mode icons.
//
// Five intelligence-mode glyphs (daily / jackpot / dual review / pattern
// memory / precomputed) plus one spatial Exchange-mode glyph
// (Aya-DNA leaf-cross — geometric placeholder, not a copyrighted Adinkra
// symbol). The exchange icon mirrors the geometric-DNA approach already
// used in src/shell/unified-shell-icons.tsx; we re-author it as data
// here so the icon registry remains data-driven without coupling to
// the shell file.

import type { IconDef } from "./icon-types.ts";

export const MODE_ICONS: Record<string, IconDef> = {
  "mode.daily_intelligence": {
    key: "mode.daily_intelligence",
    shapes: [
      { type: "path", d: "M5 16 A7 7 0 0 1 19 16" },
      { type: "line", x1: 4, y1: 16, x2: 20, y2: 16 },
      { type: "line", x1: 12, y1: 5, x2: 12, y2: 7 },
      { type: "line", x1: 17, y1: 8, x2: 18.5, y2: 6.5 },
      { type: "line", x1: 7, y1: 8, x2: 5.5, y2: 6.5 },
    ],
  },
  "mode.jackpot_intelligence": {
    key: "mode.jackpot_intelligence",
    shapes: [
      { type: "path", d: "M5 6 H19 V18 H5 Z" },
      { type: "line", x1: 5, y1: 6, x2: 5, y2: 18 },
      { type: "line", x1: 19, y1: 6, x2: 19, y2: 18 },
      { type: "path", d: "M11 9 L9 13 H13 L11 17", strokeWidth: 2 },
    ],
  },
  "mode.dual_review": {
    key: "mode.dual_review",
    shapes: [
      { type: "circle", cx: 9, cy: 12, r: 5 },
      { type: "circle", cx: 15, cy: 12, r: 5 },
    ],
  },
  "mode.pattern_memory": {
    key: "mode.pattern_memory",
    shapes: [
      { type: "circle", cx: 7, cy: 7, r: 1.2 },
      { type: "circle", cx: 12, cy: 7, r: 1.2 },
      { type: "circle", cx: 17, cy: 7, r: 1.2 },
      { type: "circle", cx: 7, cy: 12, r: 1.2 },
      { type: "circle", cx: 12, cy: 12, r: 1.6, filled: true },
      { type: "circle", cx: 17, cy: 12, r: 1.2 },
      { type: "circle", cx: 7, cy: 17, r: 1.2 },
      { type: "circle", cx: 12, cy: 17, r: 1.2 },
      { type: "circle", cx: 17, cy: 17, r: 1.2 },
    ],
  },
  "mode.precomputed": {
    key: "mode.precomputed",
    shapes: [
      { type: "polyline", points: "7,4 17,4 7,11 17,20 7,20 17,13" },
      { type: "polyline", points: "9,16 11,18 14,15" },
    ],
  },
  "mode.exchange": {
    // Aya-DNA leaf-cross. Geometric placeholder; not a literal Adinkra symbol.
    key: "mode.exchange",
    shapes: [
      { type: "path", d: "M12 4 C9 8 9 16 12 20" },
      { type: "path", d: "M12 4 C15 8 15 16 12 20" },
      { type: "path", d: "M4 12 C8 9 16 9 20 12" },
      { type: "path", d: "M4 12 C8 15 16 15 20 12" },
    ],
  },
};
